export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6264.ecf1be77.jpg";